export default "__VITE_ASSET__vOmVXGAO__"